import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import {
  THEATERS, THEATER_LOCATIONS, LOCATIONS, THEATER_WEBSITES,
  THEATER_ADDRESSES, OUTDOOR_THEATER_IDS,
} from '../constants';

// Venues directory (9/2, Josh: "maybe we should have a venues page like
// revival hub"). Every theater we track, grouped by neighborhood, each linking
// to its own page. Also a real SEO surface: one internal link per venue, which
// the calendar alone never gave them.
export default function Venues() {
  const outdoor = new Set(OUTDOOR_THEATER_IDS);
  const indoor = THEATERS.filter((t) => !outdoor.has(t.id));
  const outdoorVenues = THEATERS.filter((t) => outdoor.has(t.id));

  const Card = ({ t }) => (
    <div style={{
      border: '1px solid #d4cec4', borderRadius: '8px', padding: '14px 16px',
      background: '#faf7f2', display: 'flex', flexDirection: 'column', gap: '4px',
    }}>
      <Link
        to={`/theater/${t.slug}`}
        style={{ fontFamily: "'Cinzel', Georgia, serif", fontSize: '1rem', color: '#1a1714', textDecoration: 'none', fontWeight: 600 }}
      >
        {t.name}
      </Link>
      {THEATER_ADDRESSES[t.id] && (
        <span style={{ fontSize: '0.82rem', color: '#6b6255' }}>{THEATER_ADDRESSES[t.id]}</span>
      )}
      <div style={{ display: 'flex', gap: '12px', marginTop: '4px' }}>
        <Link to={`/theater/${t.slug}`} style={{ fontSize: '0.8rem', color: '#8b6914', textDecoration: 'none' }}>
          Showtimes →
        </Link>
        {THEATER_WEBSITES[t.id] && (
          <a href={THEATER_WEBSITES[t.id]} target="_blank" rel="noopener noreferrer"
             style={{ fontSize: '0.8rem', color: '#6b6255', textDecoration: 'none' }}>
            Website ↗
          </a>
        )}
      </div>
    </div>
  );

  const Group = ({ title, list }) => (
    list.length ? (
      <section style={{ marginBottom: '34px' }}>
        <h2 style={{
          fontFamily: "'Cinzel', Georgia, serif", fontSize: '1.15rem', color: '#1a1714',
          borderBottom: '2px solid #d4a843', paddingBottom: '6px', marginBottom: '14px',
        }}>
          {title} <span style={{ fontSize: '0.8rem', color: '#6b6255', fontWeight: 400 }}>({list.length})</span>
        </h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: '12px' }}>
          {list.sort((a, b) => a.name.localeCompare(b.name)).map((t) => <Card key={t.id} t={t} />)}
        </div>
      </section>
    ) : null
  );

  return (
    <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '0 20px 60px' }}>
      <Helmet>
        <title>NYC Repertory Cinemas & Venues | Film Revival NYC</title>
        <meta name="description" content="Every repertory and revival cinema we track in New York City, by neighborhood: Film Forum, Metrograph, BAM, Anthology Film Archives, Museum of the Moving Image, outdoor screenings and more." />
        <link rel="canonical" href="https://filmrevivalnyc.com/venues" />
      </Helmet>

      <h1 style={{ fontFamily: "'Cinzel', Georgia, serif", fontSize: '2rem', letterSpacing: '2px', margin: '0 0 6px' }}>
        Venues
      </h1>
      <p style={{ color: '#6b6255', fontSize: '0.92rem', margin: '0 0 28px', maxWidth: '640px' }}>
        Every cinema, museum, and outdoor series we track across New York City. {THEATERS.length} venues in all.
      </p>

      {LOCATIONS.map((loc) => (
        <Group key={loc} title={loc} list={indoor.filter((t) => THEATER_LOCATIONS[t.id] === loc)} />
      ))}
      <Group title="Outdoor & Seasonal" list={outdoorVenues} />
    </div>
  );
}
